var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7298_68083)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.18188 7.76799L8.47488 7.05999L9.18188 6.35299C9.4157 6.12122 9.60143 5.84554 9.72842 5.54179C9.85541 5.23804 9.92115 4.9122 9.92187 4.58298C9.92259 4.25375 9.85828 3.92763 9.73262 3.62332C9.60696 3.31902 9.42244 3.04253 9.18964 2.80974C8.95684 2.57694 8.68036 2.39241 8.37605 2.26676C8.07175 2.1411 7.74563 2.07679 7.4164 2.07751C7.08718 2.07823 6.76134 2.14397 6.45759 2.27096C6.15384 2.39795 5.87816 2.58368 5.64638 2.81749L4.93938 3.52499L4.23188 2.81799L4.93988 2.11099C5.59629 1.45458 6.48658 1.08582 7.41488 1.08582C8.34319 1.08582 9.23347 1.45458 9.88988 2.11099C10.5463 2.7674 10.9151 3.65769 10.9151 4.58599C10.9151 5.5143 10.5463 6.40458 9.88988 7.06099L9.18188 7.76799ZM7.76788 9.18199L7.06038 9.88899C6.40397 10.5454 5.51369 10.9142 4.58538 10.9142C3.65708 10.9142 2.76679 10.5454 2.11038 9.88899C1.45397 9.23258 1.08521 8.3423 1.08521 7.41399C1.08521 6.48569 1.45397 5.59541 2.11038 4.93899L2.81788 4.23199L3.52488 4.93999L2.81788 5.64699C2.58407 5.87877 2.39834 6.15445 2.27135 6.4582C2.14436 6.76195 2.07862 7.08779 2.0779 7.41701C2.07718 7.74624 2.14149 8.07236 2.26715 8.37667C2.3928 8.68097 2.57733 8.95746 2.81012 9.19025C3.04292 9.42305 3.31941 9.60758 3.62371 9.73323C3.92802 9.85889 4.25414 9.9232 4.58337 9.92248C4.91259 9.92176 5.23843 9.85602 5.54218 9.72903C5.84593 9.60204 6.12161 9.41631 6.35338 9.18249L7.06038 8.47549L7.76788 9.18199ZM7.41388 3.87849L8.12138 4.58599L4.58588 8.12099L3.87838 7.41399L7.41388 3.87849Z",
    fill: "#4A4A68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7298_68083"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.da015d45c7b697780363c560329fa237.svg";
export { ForwardRef as ReactComponent };